__turbopack_context__.v({
  "chevron": "AskAI-module__zRetNq__chevron",
  "chevronOpen": "AskAI-module__zRetNq__chevronOpen",
  "container": "AskAI-module__zRetNq__container",
  "dropdown": "AskAI-module__zRetNq__dropdown",
  "dropdownItem": "AskAI-module__zRetNq__dropdownItem",
  "dropdownItemActive": "AskAI-module__zRetNq__dropdownItemActive",
  "header": "AskAI-module__zRetNq__header",
  "icon": "AskAI-module__zRetNq__icon",
  "iconGemini": "AskAI-module__zRetNq__iconGemini",
  "iconItem": "AskAI-module__zRetNq__iconItem",
  "iconLink": "AskAI-module__zRetNq__iconLink",
  "iconLinkPersonalized": "AskAI-module__zRetNq__iconLinkPersonalized",
  "iconList": "AskAI-module__zRetNq__iconList",
  "iconPerplexity": "AskAI-module__zRetNq__iconPerplexity",
  "personalizeToggle": "AskAI-module__zRetNq__personalizeToggle",
  "splitButton": "AskAI-module__zRetNq__splitButton",
  "splitButtonDropdown": "AskAI-module__zRetNq__splitButtonDropdown",
  "splitButtonLabel": "AskAI-module__zRetNq__splitButtonLabel",
  "title": "AskAI-module__zRetNq__title",
  "toggleButton": "AskAI-module__zRetNq__toggleButton",
  "tooltip": "AskAI-module__zRetNq__tooltip",
});
